import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgEraser = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M12.6923 16.8462L21 8.53846L15.4615 3L7.15385 11.3077M12.6923 16.8462L8.53846 21L3 15.4615L7.15385 11.3077M12.6923 16.8462L7.15385 11.3077",
		stroke: "currentColor",
		strokeWidth: 2,
		strokeLinejoin: "round"
	})
});
export default SvgEraser;
